import React from "react";
import { PageHeader } from "./common";
import { Rocket } from "lucide-react";

export default function ComingSoon({ title, phase, description }) {
  return (
    <>
      <PageHeader title={title} subtitle={description || "Part of the Production module."} />
      <div className="bg-white border border-slate-200 rounded-xl p-12 text-center" data-testid="coming-soon">
        <div className="w-12 h-12 rounded-full bg-[#fce8e8] grid place-items-center mx-auto mb-4">
          <Rocket size={20} className="text-[#ab0000]" />
        </div>
        <div className="font-display text-lg font-semibold text-slate-900">{title} — coming up</div>
        <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">
          This screen lands in {phase || "an upcoming phase"} of the Production rollout. The foundation (masters, dashboard, status flow) is live now.
        </p>
      </div>
    </>
  );
}
